// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallPreviewLoader__logo-b5b31d {
  margin-top: auto;
}

.CallPreviewLoader__loader-d6aedc {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallPreview/CallPreviewLoader/CallPreviewLoader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".logo {\n  margin-top: auto;\n}\n\n.loader {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `CallPreviewLoader__logo-b5b31d`,
	"loader": `CallPreviewLoader__loader-d6aedc`
};
module.exports = ___CSS_LOADER_EXPORT___;
